import { DialogConfirmComponent } from '@aca-new/app/shared/components/modal/shared/components/dialog-confirm/dialog-confirm.component';
import { DialogService } from '@aca-new/app/shared/components/modal/shared/services/dialog.service';
import { ITableBodyRow } from '@aca-new/app/shared/components/table/shared/interfaces/table-data.interface';
import { inject, Injectable } from '@angular/core';
import { EQimaCheckboxState } from '@qima/ngx-qima';

@Injectable({
  providedIn: 'root',
})
export class PaymentSelectionValidationService {
  private readonly _dialog = inject(DialogService);

  public beforeCheckboxClick(rows: ITableBodyRow[]): boolean {
    const selectedRows: ITableBodyRow[] = rows.filter((row): boolean => row.viewData[0].checkState === EQimaCheckboxState.CHECKED);

    if (selectedRows.length === 0) {
      return true;
    }

    const firstCurrency: string = this._getCurrency(selectedRows[0]);
    const canClick: boolean = selectedRows.every((row: ITableBodyRow): boolean => {
      const currency: string = this._getCurrency(row);

      return currency === firstCurrency;
    });

    if (!canClick) {
      this._dialog.open(DialogConfirmComponent, {
        data: {
          title: 'COMMON.ERROR',
          content: 'PAYMENTS.LT_SELECT_LIMIT',
          confirmButtonLabel: 'COMMON.OK',
          hasCancel: false,
        },
      });
    }

    return canClick;
  }

  private _getCurrency(row: ITableBodyRow): string {
    const { currency } = row.originData as { currency?: unknown };

    return typeof currency === 'string' ? currency : '';
  }
}
